import { Button, Flex } from '@chakra-ui/react';
import type { KeenSliderInstance } from 'keen-slider/react';
import type { MutableRefObject } from 'react';

interface ISlideDotsProps {
  currentSlide: number;
  slider: MutableRefObject<KeenSliderInstance | null>;
}

export const SlideDots: React.FC<ISlideDotsProps> = (props): JSX.Element => {
  const { currentSlide, slider } = props;
  return (
    <Flex alignItems="center" display={{ md: 'none' }} justifyContent="center">
      {slider.current?.track.details.slides.map((_, idx) => {
        return (
          <Button
            className={currentSlide === idx ? ' active' : ''}
            key={idx}
            sx={{
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '&.active': {
                w: '12px',
                h: '12px',
                bg: 'white',
                border: '1px',
                borderColor: 'brand.red.light',
              },
            }}
            variant="dot"
            onClick={(): void => {
              slider.current?.moveToIdx(idx);
            }}
          />
        );
      })}
    </Flex>
  );
};
